"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DEFAULT_IFRAME_SRC = 'https://mindmup.github.io/3rdpartycookiecheck/start.html';
var DEFAULT_IFRAME_TITLE = 'UTThirdPartyCookieChecker';

var UTThirdPartyCookieChecker = function UTThirdPartyCookieChecker(_ref) {
  var disabledCallback = _ref.disabledCallback,
      enabledCallback = _ref.enabledCallback,
      iframeSrc = _ref.iframeSrc,
      iframeTitle = _ref.iframeTitle;
  var iframeRef = (0, _react.useRef)(null);

  var handleCallback = function handleCallback(event) {
    if (event.data === 'MM:3PCsupported' && enabledCallback) {
      return enabledCallback();
    }

    if (event.data === 'MM:3PCunsupported' && disabledCallback) {
      return disabledCallback();
    }

    return function () {
      return undefined;
    };
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('message', handleCallback, false);
    iframeRef.current.src = iframeSrc || DEFAULT_IFRAME_SRC;
    return function () {
      return window.removeEventListener('message', handleCallback, false);
    };
  }, []);
  return _react["default"].createElement("iframe", {
    ref: iframeRef,
    title: iframeTitle || DEFAULT_IFRAME_TITLE,
    style: {
      display: 'none'
    }
  });
};

UTThirdPartyCookieChecker.propTypes = {
  disabledCallback: _propTypes.func,
  enabledCallback: _propTypes.func,
  iframeSrc: _propTypes.string,
  iframeTitle: _propTypes.string
};

var _default = (0, _react.memo)(UTThirdPartyCookieChecker);

exports["default"] = _default;